// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agenda-card {
  display: flex;
  flex: 1;
}
.agenda-card__content {
  flex: 1 0 0%;
  flex: 1;
  display: flex;
  border-radius: var(--default-border-radius);
}
.agenda-card__wrapper {
  padding: var(--agenda-card-padding);
  flex: 1 0 100%;
  display: flex;
  flex-direction: column;
}
.agenda-card__title {
  margin: 0 !important;
  margin-bottom: 10px !important;
}
.agenda-card__time--card {
  margin: 0;
  margin-bottom: 5px;
  font-weight: 600;
  font-size: 30px;
  line-height: 36px;
}
.agenda-card__date-tag {
  font-size: 16px;
  display: var(--agenda-datetime-display);
}
.agenda-card__date-info-wrapper {
  display: var(--agenda-datetime-display);
}
.agenda-card__texts {
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.agenda-card__speakers-container {
  padding-top: 1.7rem;
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
}
.agenda-card__speakers-container-label {
  margin-bottom: -1rem;
  padding-top: 1rem;
  font-size: 16px;
}
.agenda-card *:not(.agenda-card__speakers-item) + .agenda-card__speakers-item {
  margin-top: auto;
}
.agenda-card__speaker-wrapper .ant-card-meta-detail .ant-card-meta-title {
  margin-bottom: 0px !important;
}
.agenda-card__speaker-wrapper:hover {
  cursor: pointer;
}
.agenda-card__speaker-wrapper:hover.no-hover {
  cursor: default !important;
}
.agenda-card__speaker {
  display: flex;
  align-items: center;
}
.agenda-card__speaker .ant-avatar {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid var(--speaker-picture-border-color);
}
.agenda-card__speaker_see-more {
  font-size: 0.7rem;
  opacity: 0.6;
  margin: 0 !important;
}
.agenda-card__content--list-item .agenda-card__wrapper {
  flex: 1 0 100%;
  display: flex;
  flex-direction: row;
  gap: 18px;
}
@media (min-width: 992px) {
  .agenda-card__content--list-item .agenda-card__wrapper {
    gap: 25px;
  }
}
.agenda-card .ant-card-body {
  padding: 0;
  flex: 1;
  flex-direction: column;
  display: flex;
}
.agenda-card {
  /* Nested agenda styles */
}
.agenda-card__collapsible {
  width: 100%;
  border-radius: var(--default-border-radius);
}
.agenda-card__collapsible .ant-collapse-header-text,
.agenda-card__collapsible .ant-collapse-expand-icon {
  cursor: pointer !important;
}
.agenda-card__collapsible .ant-collapse-header-text {
  flex: auto !important;
}
.agenda-card__nested-item:not(:first-child) {
  padding-top: var(--agenda-card-padding);
}
.agenda-card__nested-item:not(:last-child) {
  padding-bottom: var(--agenda-card-padding);
  border-bottom: 1px solid var(--default-border-color);
}
.agenda-card__collapsible--list-item .agenda-card__collapsible-header-wrapper {
  display: flex;
  gap: 18px;
}
@media (min-width: 992px) {
  .agenda-card__collapsible--list-item .agenda-card__collapsible-header-wrapper {
    gap: 25px;
  }
}
.agenda-card__collapsible--list-item.ant-collapse {
  border: 0 !important;
}
.agenda-card__collapsible--list-item .ant-collapse-content-box {
  padding: 20px 0 30px 25px !important;
}
.agenda-card__nested-title {
  margin: 0 !important;
  margin-bottom: 10px !important;
}
.agenda-card__avatar.is-hidden {
  visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/AgendaItem/AgendaItem.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,OAAA;AADJ;AAGI;EACI,YAAA;EACA,OAAA;EACA,aAAA;EACA,2CAAA;AADR;AAII;EACI,mCAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AAFR;AAKI;EACI,oBAAA;EACA,8BAAA;AAHR;AAMI;EACI,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAJR;AAOI;EACI,eAAA;EACA,uCAAA;AALR;AAQI;EACI,uCAAA;AANR;AASI;EACI,mBAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;AAPR;AAUI;EACI,mBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;AARR;AAWI;EACI,oBAAA;EACA,iBAAA;EACA,eAAA;AATR;AAYI;EACI,gBAAA;AAVR;AAcQ;EACI,6BAAA;AAZZ;AAgBI;EACI,eAAA;AAdR;AAgBQ;EACI,0BAAA;AAdZ;AAkBI;EACI,aAAA;EACA,mBAAA;AAhBR;AAkBQ;EACI,aAAA;EACA,cAAA;EACA,qDAAA;AAhBZ;AAmBQ;EACI,iBAAA;EACA,YAAA;EACA,oBAAA;AAjBZ;AAsBQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AApBZ;AAsBY;EANJ;IAOQ,SAAA;EAnBd;AACF;AAuBI;EACI,UAAA;EACA,OAAA;EACA,sBAAA;EACA,aAAA;AArBR;AA3FA;EAmHI,yBAAA;AArBJ;AAsBI;EACI,WAAA;EACA,2CAAA;AApBR;AAsBQ;;EAEI,0BAAA;AApBZ;AAuBQ;EACI,qBAAA;AArBZ;AAyBI;EACI,uCAAA;AAvBR;AA0BI;EACI,0CAAA;EACA,oDAAA;AAxBR;AA4BQ;EACI,aAAA;EACA,SAAA;AA1BZ;AA4BY;EAJJ;IAKQ,SAAA;EAzBd;AACF;AA4BQ;EACI,oBAAA;AA1BZ;AA6BQ;EACI,oCAAA;AA3BZ;AA+BI;EACI,oBAAA;EACA,8BAAA;AA7BR;AAiCQ;EACI,kBAAA;AA/BZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
